module.exports = __webpack_public_path__ + "img/error-security-koin.b9643bdc.png";